import React from 'react';
import * as Yup from 'yup';
import { Alert, Stack } from '@mui/material';
import { PasswordInput } from './Fields';

/** Current / new / confirm fields, shared by the Change password dialog and the first-sign-in screen. */
export const PasswordChangeSchema = Yup.object().shape({
  current_password: Yup.string().required('Enter your current password'),
  new_password: Yup.string()
    .min(8, 'At least 8 characters')
    .notOneOf([Yup.ref('current_password')], 'Choose a different password')
    .required('Enter a new password'),
  confirm_password: Yup.string()
    .oneOf([Yup.ref('new_password')], 'Passwords must match')
    .required('Confirm your new password'),
});

export const PASSWORD_CHANGE_INITIAL = { current_password: '', new_password: '', confirm_password: '' };

// The server's verdict on a field (a wrong current password, a rejected new
// one) belongs under that field, in Formik's errors shape; null if there's none.
export const passwordFieldErrors = (error) => {
  const errors = error?.response?.data?.errors;
  if (!errors || typeof errors !== 'object' || Array.isArray(errors)) return null;
  const fieldErrors = {};
  ['current_password', 'new_password'].forEach((field) => {
    if (Array.isArray(errors[field])) fieldErrors[field] = errors[field].join(', ');
  });
  return Object.keys(fieldErrors).length ? fieldErrors : null;
};

const PasswordChangeFields = ({ error, currentLabel = 'Current password' }) => (
  <Stack spacing={2.5}>
    {error && <Alert severity="error">{error}</Alert>}
    <PasswordInput name="current_password" label={currentLabel} autoComplete="current-password" autoFocus required />
    <PasswordInput name="new_password" label="New password" autoComplete="new-password" helperText="At least 8 characters" required />
    <PasswordInput name="confirm_password" label="Confirm new password" autoComplete="new-password" required />
  </Stack>
);

export default PasswordChangeFields;
